import { IntegrationCards } from 'common/subdomain/admin/AdminIntegrationSettings/constants';
import { Integrations as AutopilotIntegrations } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';
import { getEnabledSyncIntegrationMap } from 'common/util/syncIntegrations';

import type { Company, CompanyActiveIntegrations } from 'common/api/endpoints/companies';
import type { IntegrationNames } from 'common/constants/integrations';

export const getEnabledIntegrationCards = (activeIntegrations: CompanyActiveIntegrations) => {
  return Object.entries(IntegrationCards)
    .filter(([key]) => !!activeIntegrations[key as IntegrationNames])
    .map(([_key, value]) => value);
};

export const getEnabledAutopilotIntegrations = (company: Company) => {
  const companyIntegrations = getEnabledSyncIntegrationMap(company);
  return AutopilotIntegrations.filter(({ name }) => companyIntegrations[name]);
};
